import PropTypes from 'prop-types';

import MMFallFlavorsActive from './MMFallFlavorsActive';
import MMFallFlavorsInactive from './MMFallFlavorsInactive';

function MMFallFlavors({ className, isActive, width }) {
    return isActive ? (
        <MMFallFlavorsActive className={className} width={width} />
    ) : (
        <MMFallFlavorsInactive className={className} width={width} />
    );
}

export default MMFallFlavors;

MMFallFlavors.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    width: PropTypes.number,
};

MMFallFlavors.defaultProps = {
    className: '',
    isActive: true,
    width: 24,
};
